/*global ajaxurl */
import axios from 'axios';
import Qs from 'qs';

export default {
  init() {
    let recentScroll = false;

    // Choose scroll element based on screen size on load
    $(window).load(function() {
      if ($(window).width() < 992) {
        loadMoreNews('.sidebar');
      } else {
        loadMoreNews('.content-info');
      }
    });
  
    // Choose scroll element based on screen size on resize
    $(window).resize(function() {
      if ($(window).width() < 992) {
        loadMoreNews('.sidebar');
      } else {
        loadMoreNews('.content-info');
      }
    });

    //  When the scrollElement appears in the viewport
    //  trigger and ajax post to get more news
    function loadMoreNews(scrollElement) {
      $(window).scroll(function() {
        if ($(scrollElement).visible(true) && !recentScroll) {
          // Set recentScroll to false to prevent another ajax request from being triggered
          recentScroll = true;
          // Count number of news articles so we know how much to offset each query by
          let offset = $('#news-items article').length;

          $('#loading').show();

          let data = {
            action: 'load_news',
            offset: offset,
          };

          axios.post(ajaxurl, Qs.stringify(data)).then(response => {
            $('#news').append(response.data.data.news);
            $('#loading').hide();
            // Once the ajax response has returned set the recentScroll varialbe back to false after 1 second
            window.setTimeout(() => {
              recentScroll = false;
            }, 1000);
          });
        }
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/news.js